<template>
  <d-modal @close="handleClose" size="lg">
    <d-modal-header @click.stop>
      <d-modal-title>
        {{ $t('marketCustomersImportPopup.importHistoryTitle') }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body
      class="py-0 px-3"
      @click.stop>
      <table
        v-if="!loadError && dataLoaded"
        class="table table-sm">
        <thead>
          <tr>
            <th>{{ $t('marketCustomersImportPopup.importList.date') }}</th>
            <th>{{ $t('marketCustomersImportPopup.importList.author') }}</th>
            <th>{{ $t('marketCustomersImportPopup.importList.count') }}</th>
            <th>{{ $t('marketCustomersImportPopup.importList.delete') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(importData, index) of imports"
            :key="'import-list-' + index">
            <td>{{ importData.created_at }}</td>
            <td>{{ importData.user_name }}</td>
            <td>{{ importData.customers_count }}</td>
            <td>
              <d-button
                theme="danger"
                @click.native="removeImport(importData.id)"
                :disabled="!!removeInProgress"
                :title="$t('ui.delete')">
                <i class="material-icons">delete</i>
              </d-button>
            </td>
          </tr>
        </tbody>
      </table>

      <d-alert
        v-if="!dataLoaded && !loadError"
        show
        theme="light">
        {{ $t('ui.dataLoading') }}&hellip;
      </d-alert>

      <d-alert
        v-if="loadError"
        show
        theme="warning">
        {{ $t('marketCustomersImportPopup.errorWhileLoadingImportsList') }}
      </d-alert>

      <d-alert
        v-if="dataLoaded && imports.length === 0"
        show
        theme="light">
        {{ $t('marketCustomersImportPopup.importHistoryIsEmpty') }}
      </d-alert>
    </d-modal-body>
  </d-modal>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import ListUtils from './../../utils/ListUtils.js';

export default {
  name: 'market-customers-import-history-popup',
  data () {
    return {
      dataLoaded: false,
      imports: [],
      loadError: false,
      removeInProgress: false
    };
  },
  mounted () {
    this.loadData();
  },
  methods: {
    loadData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/market-customers/imports/items',
        outputKey: 'imports',
        loadedKey: 'dataLoaded',
        errorKey: 'loadError',
      });
    },
    removeImport (importID) {
      this.removeInProgress = true;

      ListUtils.removeItem({
        $http: this.$http,
        endpointBase: '/market-customers/imports/delete/',
        id: importID,
        successTitle: this.$t('marketCustomersImportPopup.importRemoveSuccessTitle'),
        successText: this.$t('marketCustomersImportPopup.importRemoveSuccessText'),
        confirmTitle: this.$t('marketCustomersImportPopup.importDeleteConfirmTitle'),
        confirmText: this.$t('ui.deleteConfirmText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('marketCustomersImportPopup.importRemoveErrorText'),
        successAction: () => {
          this.removeInProgress = false;
          this.dataLoaded = false;
          this.loadData();
          this.$bus.$emit('market-customers-reload-needed');
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    },
    handleClose () {
      this.$bus.$emit('market-customers-import-history-popup-close');
    },
    cancel () {
      this.handleClose();
    }
  }
}
</script>
